/* eslint-disable import/prefer-default-export */
import { createActions } from 'redux-actions';
import { request } from '../../services';

const {
  taskListRequest,
  taskListSuccess,
  taskListFailure,
} = createActions({
  TASK_LIST_SUCCESS: json => json.tasks,
}, 'TASK_LIST_REQUEST', 'TASK_LIST_FAILURE');

export function requestTaskList() {
  return (dispatch) => {
    dispatch(taskListRequest());
    return request('tasks')
      .then(({ json }) => {
        dispatch(taskListSuccess(json));
      },
      (error) => {
        dispatch(taskListFailure(error));
      });
  };
}



// WEBPACK FOOTER //
// ./client/app/shared/actionCreators/tasks.js